<template>
  <div class="main-container">
    <div class="item settlement-status" v-if="infoForm.id">
      发布状态：
      <div v-if="infoForm.releaseStatus == 0" class="tag-settled">未发布</div>
      <div v-else class="tag-be">已发布</div>
    </div>

    <div @click="foldBtn(1)" class="foldblock">
      <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">基本信息</span>
    </div>
    <Form :model="infoForm" ref="infoFormRef" class="page-form" :label-width="110" v-show="fold">
      <FormItem label="结算单名称" prop="reportName" class="full" style="width: 66.5%" :rules="$units.formRule.required('请输入结算报表名称')">
        <Input type="text" v-model="infoForm.reportName" placeholder="请输入" />
      </FormItem>

      <div class="full">
        <FormItem label prop="settlementDate" :rules="$units.formRule.required('请选择结算周期')">
          <span slot="label" class="label">
            结算周期<span class="tip-icon">?</span>
            <div class="pop-tip">
              <span>显示在业务员展业端的结算时间</span>
              <div class="arrow"></div>
            </div>
          </span>
          <DatePicker
            :disabled="nextData.settled"
            type="date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            @on-change="infoForm.settlementDate = $event"
            :value="infoForm.settlementDate"
          ></DatePicker>
        </FormItem>
      </div>

      <FormItem label="备注" prop="remark" class="full" style="width: 66.5%">
        <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="infoForm.remark" placeholder="请输入" />
      </FormItem>
    </Form>
    <Divider />

    <div @click="foldBtn(2)" class="foldblock">
      <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">结算报表</span>
    </div>

    <div class="tableBox" v-show="foldData">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn-disabled" v-if="nextData.settled">删除</span>
          <span class="table-btn" @click="delRow([row.id], 0)" v-else>删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>

    <div style="height: 110px"></div>
    <div class="footer-action">
      <div>
        <Button type="primary" class="btn" @click="save(false, 0)" :loading="saveLoading">保存</Button>
        <Button type="primary" ghost @click="back('/financialManage/salesmanPaySettlement')">返回</Button>
        <Button type="primary" ghost @click="save(true, 2)" :disabled="nextData.settled">选择报表</Button>
        <Button type="primary" ghost @click="save(true, 1)" v-if="!nextData.settled" :loading='nextStepLoading'>下一步</Button>
        <Button type="primary" ghost @click="settledNextStep" v-else>下一步</Button>
      </div>
    </div>

    <!-- 选择报表 -->
    <selectPolicyPopUp ref="selectPolicyRef" :reportId="reportId" @success="searchAjax()"></selectPolicyPopUp>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
import selectPolicyPopUp from '../components/selectPolicyPopUp';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    selectPolicyPopUp
  },
  props: {
    nextData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      saveLoading: false,
      nextStepLoading: false,
      fold: true,
      foldData: true,
      isAdd: 0,
      infoForm: {
        settlementDate: ''
      },
      total: 0,
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '报表名称',
          align: 'center',
          key: 'reportName',
          minWidth: 250
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 250,
          tooltip: true,
          tooltipMaxWidth: 600
        },
        {
          title: '报表类型',
          align: 'center',
          key: 'type',
          minWidth: 250,
          render(h, params) {
            let type = params.row.type;
            if (type == 1) {
              return <span>基本法</span>;
            } else if (type == 2) {
              return <span>增员活动</span>;
            } else if (type == 3) {
              return <span>团险</span>;
            } else if (type == 4) {
              return <span>出单活动</span>;
            } else if (type == 5) {
              return <span>签约活动</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 80,
          render(h, params) {
            let settlementStatus = params.row.settlementStatus;
            if (settlementStatus == 1) {
              return <span>已结算</span>;
            } else {
              return <span>待结算</span>;
            }
          }
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ],
      selectArr: [],
      tableData: [],
      reportId: null
    };
  },
  created() {
    if (!this.$units.pointAction('offline_81_2_2')) {
      this.columns.splice(this.columns.length - 1, 1);
    }

    this.isAdd = this.$route.query.isAdd;
    this.reportId = this.$route.query.reportId;
    let today = new Date();
    this.infoForm.settlementDate = filter.filterTime(today, 'YYYY-MM-DD');
    if (this.isAdd == 0 && this.reportId) {
      this.getDetailData();
      this.searchAjax();
    }
  },
  methods: {
    getData() {
      this.reportId = this.nextData.reportId;
      this.getDetailData();
      this.searchAjax();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/userSalaryReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.infoForm = res.data;
        this.$nextTick(() => {
          this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
      });
    },

    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementReport/read/page',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          salaryReportId: this.reportId
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 删除
    delRow(ids, isAll) {
      if (!this.$units.pointAction('offline_81_2_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/userSalaryData/batchDel',
          type: 'POST',
          data: {
            settlementReportIds: ids,
            reportId: this.reportId,
            isAll
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
          this.selectArr = [];
        });
      });
    },

    // 保存
    save(mark, btn) {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (!mark && !btn) {
          this.saveLoading = true;
        }
        if (mark && btn == 1) {
          this.nextStepLoading = true;
        }
        this.$http({
          url: '/buz/userSalaryReport/saveReport',
          type: 'POST',
          data: {
            id: this.reportId,
            reportName: this.infoForm.reportName, //结算报表名称
            settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'), //结算日期
            remark: this.infoForm.remark, //备注
            step: this.nextData.settled || btn == 1 ? 2 : 1
          }
        }).then(res => {
          this.reportId = res.data.id;
          if (!this.reportId) {
            this.$notice.success('操作成功');
          }
          if (mark && btn == 2) {
            this.$refs.selectPolicyRef.open();
          } else if (mark && btn == 1) {
            this.nextStep();
          }
          this.searchAjax();
          this.saveLoading = false;
        });
      });
    },

    // 下一步
    nextStep() {
      this.$http({
        url: '/buz/userSalaryDetails/buildSalaryDetail',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('next', {
          reportId: this.reportId,
          reportName: this.infoForm.reportName,
          settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD')
        });
        this.nextStepLoading = false;
      }).catch(()=>{
        this.nextStepLoading = false;
      });
    },

    // 已结算下一步
    settledNextStep() {
      this.$emit('next', {
        reportId: this.reportId,
        reportName: this.infoForm.reportName,
        settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD')
      });
    },

    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold;
      } else {
        this.foldData = !this.foldData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  color: #515c6f;
  font-size: 14px;
  margin-left: 20px;
}
.settlement-status {
  position: absolute;
  right: 20px;
  margin-top: 1px;
  margin-left: 20px;
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.foldblock {
  margin-bottom: 15px;
  display: inline-block;
  cursor: pointer;
  .title {
    font-size: 16px;
    font-weight: 800;
    margin: 0 10px;
    color: #3c464f;
  }
  .iconColor {
    color: #727c8e;
    margin-right: 2px;
  }
}
.form-container {
  padding: 0 30px;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 6px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    top: -50px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 9px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      bottom: -4px;
      left: 74px;
      transform: rotateZ(135deg);
    }
  }
}
.tableBox {
  margin-top: 10px;
  .table-btn-disabled {
    cursor: no-drop;
    color: #c5c8ce;
  }
}
.footer-action {
  position: fixed;
  bottom: 0px;
  background: #fff;
  z-index: 999 !important;
  width: 98%;
  height: 120px;
  line-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
